import { Action } from "redux";
import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

import * as types from "./actionTypes";

import { ICalendarSettingsState } from "../classes/state";

// Functions that call sequences of actions; actual actions created at end of this file.

export function setCalendarSettingsFromPortlet(calendarSettings: ICalendarSettingsState) {
  return (dispatch) => {
    dispatch(setCalendarSettingsFromPortlet_ONLY(calendarSettings));
    dispatch(updateToAndFromDates(""));
  };
}

export function setViewMode(viewMode: string) {
  return (dispatch) => {
    dispatch(setViewMode_ONLY(viewMode));
    dispatch(updateToAndFromDates(""));
  };
}

export function setEventScreenMode(mode: string) {
  return (dispatch) => {
    dispatch(setEventScreenMode_ONLY(mode));
  };
}

export function setEventId(eventId: number) {
  return (dispatch) => {
    dispatch(setEventId_ONLY(eventId));
  };
}

export function setiCalStartDate(iCalStartDate: Date) {
  return (dispatch) => {
    dispatch(setiCalStartDate_ONLY(iCalStartDate));
  };
}

export function setDisplayedEventLocalStartDate(localStartDate: Date) {
  return (dispatch) => {
    dispatch(setDisplayedEventLocalStartDate_ONLY(localStartDate));
  };
}

export function setDisplayedEventLocalEndDate(localEndDate: Date) {
  return (dispatch) => {
    dispatch(setDisplayedEventLocalEndDate_ONLY(localEndDate));
  };
}

export function setCurrentYear(year: number) {
  return (dispatch) => {
    dispatch(setCurrentYear_ONLY(year));
    dispatch(setViewMode_ONLY("MONTHLY"));
    dispatch(updateToAndFromDates(""));
  };
}

export function setCurrentMonth(month: number) {
  return (dispatch) => {
    dispatch(setCurrentMonth_ONLY(month));
    dispatch(updateToAndFromDates(""));
  };
}

export function setCurrentDateToToday() {
  return (dispatch) => {
    dispatch(setCurrentDateToToday_ONLY(""));
    dispatch(updateToAndFromDates(""));
  };
}

export function setCurrentDateToPreviousPeriod() {
  return (dispatch) => {
    dispatch(setCurrentDateToPreviousPeriod_ONLY(""));
    dispatch(updateToAndFromDates(""));
  };
}

export function setCurrentDateToNextPeriod() {
  return (dispatch) => {
    dispatch(setCurrentDateToNextPeriod_ONLY(""));
    dispatch(updateToAndFromDates(""));
  };
}

export function setCurrentDate(date: Date) {
  return (dispatch) => {
    dispatch(setCurrentDate_ONLY(date));
  };
}

export function setSelectedDate(date: Date) {
  return (dispatch) => {
    dispatch(setSelectedDate_ONLY(date));
  };
}

// Actual action creators:

const actionCreator = actionCreatorFactory();

export const setCalendarSettingsFromPortlet_ONLY = actionCreator<ICalendarSettingsState>(types.SET_CALENDAR_SETTINGS_ONLY);

export const setCurrentYear_ONLY = actionCreator<number>(types.SET_CURRENT_YEAR_ONLY);
export const setCurrentMonth_ONLY = actionCreator<number>(types.SET_CURRENT_MONTH_ONLY);
export const setCurrentDateToToday_ONLY = actionCreator<string>(types.SET_CURRENT_DATE_TO_TODAY_ONLY);
export const setCurrentDateToPreviousPeriod_ONLY = actionCreator<string>(types.SET_CURRENT_DATE_TO_PREVIOUS_PERIOD_ONLY);
export const setCurrentDateToNextPeriod_ONLY = actionCreator<string>(types.SET_CURRENT_DATE_TO_NEXT_PERIOD_ONLY);
export const setCurrentDate_ONLY = actionCreator<Date>(types.SET_CURRENT_DATE_ONLY);

export const setSelectedDate_ONLY = actionCreator<Date>(types.SET_SELECTED_DATE_ONLY);

export const setViewMode_ONLY = actionCreator<string>(types.SET_VIEW_MODE_ONLY);
export const setEventScreenMode_ONLY = actionCreator<string>(types.SET_EVENT_SCREEN_MODE_ONLY);

export const updateToAndFromDates = actionCreator<string>(types.UPDATE_TO_AND_FROM_DATES);

export const setEventId_ONLY = actionCreator<number>(types.SET_EVENT_ID);

export const setiCalStartDate_ONLY = actionCreator<Date>(types.SET_ICAL_START_DATE);

export const setDisplayedEventLocalStartDate_ONLY = actionCreator<Date>(types.SET_DISPLAYED_EVENT_START_DATE);
export const setDisplayedEventLocalEndDate_ONLY = actionCreator<Date>(types.SET_DISPLAYED_EVENT_END_DATE);
